import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReportsChart from 'components/Reports/ReportsChart';
import reportChartSelector from 'selectors/reportChartSelector';
import ListStats from 'components/Reports/ListStats';
import Stats from 'components/Reports/Stats';
import Filters from 'components/Reports/Filters';
import { resetReport } from 'redux/actions/reportActions';


const Reports = (props) => {
  useEffect(() => () => {
    props.resetReport();
  }, []);

  return (
    <div className="reports">
      <Filters
        location={props.location}
        initFilterParams={props.initFilterParams}
        hideCampaignManagersFilter={props.hideCampaignManagersFilter}
        hideCampaignsFilter={props.hideCampaignsFilter}
        hideAccountsFilter={props.hideAccountsFilter}
        hidePlanTypesFilter={props.hidePlanTypesFilter}
        hideSequencesFilter={props.hideSequencesFilter}
        hideESPFilter={props.hideESPFilter}
        isCampaignReportsTab={props.isCampaignReportsTab}
      />
      <Stats />
      <ReportsChart
        className="mt-2 reports-chart mb-3"
        dataSource={props.reportData}
        loading={props.loading}
      />
      <ListStats location={props.location} match={props.match} />
    </div>
  );
};


Reports.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
    path: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
  initFilterParams: PropTypes.shape({
    dateSelector: PropTypes.string,
    account__id: PropTypes.shape({}),
    campaign__id: PropTypes.shape({}),
    sequences__id: PropTypes.shape({}),
    campaign__campaign_manager__id: PropTypes.shape({}),
    subscription_type__id: PropTypes.shape({}),
    startDate: PropTypes.string,
    endDate: PropTypes.string,
  }),
  hideCampaignManagersFilter: PropTypes.bool,
  hideCampaignsFilter: PropTypes.bool,
  hideAccountsFilter: PropTypes.bool,
  hidePlanTypesFilter: PropTypes.bool,
  hideSequencesFilter: PropTypes.bool,
  hideESPFilter: PropTypes.bool,
  isCampaignReportsTab: PropTypes.bool,
  loading: PropTypes.bool,
  resetReport: PropTypes.func.isRequired,
  reportData: PropTypes.arrayOf(PropTypes.shape({
    date: PropTypes.string,
    opened: PropTypes.number,
    interested: PropTypes.number,
    expanded_interested: PropTypes.string,
    not_now: PropTypes.number,
    bounced: PropTypes.number,
    delivered: PropTypes.number,
    replied: PropTypes.number,
  })),
};

Reports.defaultProps = {
  initFilterParams: null,
  hideCampaignManagersFilter: false,
  hideCampaignsFilter: false,
  hideAccountsFilter: false,
  hidePlanTypesFilter: false,
  hideSequencesFilter: false,
  hideESPFilter: false,
  isCampaignReportsTab: false,
  loading: false,
  reportData: [],
};

export default connect(state => ({
  reportData: reportChartSelector(state.report),
  loading: state.report.loading,
}), { resetReport })(Reports);
